
const DonationHeader = () => {
  return (
    <div className="mb-10 text-center">
      <h1 className="mb-3 text-4xl font-bold bg-gradient-to-r from-[#9b87f5] to-[#6E59A5] bg-clip-text text-transparent">
        Apoya el desarrollo de SeekArt
      </h1>
      <p className="mx-auto max-w-2xl text-lg text-gray-700">
        Tu contribución nos ayuda a seguir mejorando la plataforma y a crear nuevas funcionalidades para la comunidad de Artistas y Seguidores. Juntos podemos construir un espacio más grande, inclusivo y lleno de oportunidades para todos. ¡Gracias por ser parte de este viaje creativo!
      </p>
    </div>
  );
};

export default DonationHeader;
